var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPin48Line = function SvgIconPin48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 39.54a2.89 2.89 0 0 1-1.93-.73c-5.85-5.19-11.27-10.88-11.27-17.31a13.2 13.2 0 0 1 26.4 0c0 6.43-5.42 12.12-11.28 17.31a2.9 2.9 0 0 1-1.92.73Zm0-28a9.668 9.668 0 0 0-9.8 10c0 4 2.84 8.25 9.8 14.47 6.95-6.22 9.8-10.43 9.8-14.47a9.67 9.67 0 0 0-9.8-10Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.008 27.932a6.63 6.63 0 1 1 .103-13.26 6.63 6.63 0 0 1-.103 13.26Zm0-10a3.501 3.501 0 0 0-.78.08 3.29 3.29 0 0 0-2.4 4.108 3.34 3.34 0 0 0 .84 1.442 3.302 3.302 0 1 0 4.67-4.67 3.25 3.25 0 0 0-2.34-.95l.01-.01Z",
    fill: "current"
  })));
};
export default SvgIconPin48Line;